import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[wfmDomTemplate]'
})
export class DomTemplateDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input()
  set wfmDomTemplate(template: string | HTMLElement) {
    this.removeTemplate();
    if (typeof template === 'string') {
      // create a div to help parssing string to html.
      let newTemplate: HTMLElement = this.document.createElement('div');
      // SECURITY: This directive is used for application-controlled DOM templates,
      // not user-generated content. Templates are defined by developers in code.
      newTemplate.innerHTML = this.sanitizer.bypassSecurityTrustHtml(template) as string; // NOSONAR

      // if div contains a single child, ignore div and use child instead
      if (newTemplate.firstElementChild === newTemplate.lastElementChild) {
        newTemplate = newTemplate.firstElementChild as HTMLElement;
        newTemplate.remove();
      }

      template = newTemplate;
    }
    this.$wfmDomTemplate = template;
  }

  get wfmDomTemplate(): string | HTMLElement {
    return this.$wfmDomTemplate;
  }

  private $wfmDomTemplate: HTMLElement;

  private appended = false;
  private init = false;

  private get document(): Document {
    return this.$document as Document;
  }

  constructor(@Inject(DOCUMENT) private $document: any, private element: ElementRef, private sanitizer: DomSanitizer) {}

  ngAfterViewInit(): void {
    this.init = true;
    this.appendTemplate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.wfmDomTemplate && this.wfmDomTemplate) {
      this.appendTemplate();
    }
  }

  ngOnDestroy(): void {
    this.removeTemplate();
  }

  private appendTemplate() {
    if (this.init && !this.appended && this.$wfmDomTemplate instanceof HTMLElement) {
      (this.element.nativeElement as HTMLElement).append(this.$wfmDomTemplate);
      this.appended = true;
    }
  }

  private removeTemplate() {
    this.$wfmDomTemplate && this.$wfmDomTemplate.remove && this.$wfmDomTemplate.remove();
    this.appended = false;
  }
}
